/** Up to two initials from a display name: "Test User" → "TU", "NokNok" → "NO". */
export function initialsFor(name: string) {
	const [first = "", second] = name.trim().split(/\s+/);
	const letters = second
		? `${first.charAt(0)}${second.charAt(0)}`
		: first.slice(0, 2);
	return letters.toUpperCase();
}
